module.exports = __webpack_public_path__ + "assets/img/wa-hikaritokage.9ce8d92e.svg";